(() => {
  document.querySelectorAll('[data-fp-customer-video]').forEach(card => {
    if (card.dataset.videoReady) return;
    card.dataset.videoReady = 'true';
    const dialog = card.querySelector('dialog');
    const slot = dialog.querySelector('.fp-video-slot');
    let trigger;
    const stop = () => {
      const video = slot.querySelector('video');
      if (video) video.pause();
      document.documentElement.classList.remove('fp-video-is-open');
      if (trigger) trigger.focus({preventScroll: true});
    };
    card.querySelectorAll('[data-fp-video-open]').forEach(link => {
      link.addEventListener('click', event => {
        if (!dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        if (!slot.querySelector('video')) {
          slot.append(dialog.querySelector('template').content.cloneNode(true));
          slot.querySelector('video').addEventListener('error', () => {
            dialog.querySelector('.fp-video-error').hidden = false;
          });
        }
        dialog.showModal();
        document.documentElement.classList.add('fp-video-is-open');
        const playback = slot.querySelector('video').play();
        if (playback) playback.catch(() => {});
      });
    });
    dialog.querySelector('[data-fp-video-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', stop);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && dialog.open) slot.querySelector('video')?.pause();
    });
  });
})();
